/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_2_DescInputs */

const es_home_features_item_2_desc = /** @type {(inputs: Home_Features_Item_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive, Gmail, Google Calendar, Dropbox, Microsoft 365.`)
};

const en_home_features_item_2_desc = /** @type {(inputs: Home_Features_Item_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive, Gmail, Google Calendar, Dropbox, Microsoft 365.`)
};

/**
* | output |
* | --- |
* | "Google Drive, Gmail, Google Calendar, Dropbox, Microsoft 365." |
*
* @param {Home_Features_Item_2_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_2_desc = /** @type {((inputs?: Home_Features_Item_2_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_2_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_2_desc(inputs)
	return en_home_features_item_2_desc(inputs)
});
export { home_features_item_2_desc as "home.features.item_2_desc" }